import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass, ArrowLeft } from 'lucide-react';

/**
 * Página não encontrada dentro de uma loja existente.
 *
 * Location: src/components/common
 * Why: diferente de `StoreNotFound`, que é a loja inteira não existir. Aqui a
 * loja carregou, o tema dela está aplicado e só este endereço não leva a lugar
 * nenhum — então a saída oferecida é voltar para a loja, não recarregar.
 */
export function PageNotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
        <Compass className="h-8 w-8 text-primary" />
      </div>

      <h1 className="mb-2 font-display text-2xl font-bold text-foreground">
        {t('store.notFound.title')}
      </h1>

      <p className="mb-6 max-w-sm text-sm text-muted-foreground">
        {t('store.notFound.description')}
      </p>

      <Link
        to="/"
        className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-opacity hover:opacity-90"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('store.notFound.backToStore')}
      </Link>
    </div>
  );
}
